export default {
  MessagePresenter: {
    sentAVideo: 'sent a video',
    sendABid: 'sent a bid',
  },
  realEstateAgent: {
    LoanOfficerPresenter: {
      notSet: 'Not Set',
    },
  },
  LoanOfficerPresenter: {
    notSet: 'Not Set',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/presenters.js